import { ChannelType, Direction } from '@dxp/core/types';

export interface IActivityHistoryFilterState {
    queueOrAgentSelection: string[];
    channelSelection: number[];
    channelTypesSelection: ChannelType[];
    directionSelection: Direction;
    sortSelection: 'oldest' | 'newest';
    completionCodeSelection: string[];
    subjectId?: string;
    typeId?: IActivityHistoryFilterStateTypeId | undefined;
    dateFrom: Date;
    dateTo: Date | null;
}

export enum IActivityHistoryFilterStateTypeId {
    CUSTOMER_ACTIVITY_HISTORY = 'CUSTOMER_ACTIVITY_HISTORY',
    AGENT_ACTIVITY_HISTORY = 'AGENT_ACTIVITY_HISTORY',
    MY_ACTIVITY_HISTORY = 'MY_ACTIVITY_HISTORY',
}
